// BookIcon.jsx

import React from "react";

export const SubjectIcon = ({
  width = 18,
  height = 20,
  fill = "#1C1B1F",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4 14H6V2H4V14ZM3 20C2.16667 20 1.45833 19.7083 0.875 19.125C0.291667 18.5417 0 17.8333 0 17V3C0 2.16667 0.291667 1.45833 0.875 0.875C1.45833 0.291667 2.16667 0 3 0H14V16H3C2.71667 16 2.47917 16.0958 2.2875 16.2875C2.09583 16.4792 2 16.7167 2 17C2 17.2833 2.09583 17.5208 2.2875 17.7125C2.47917 17.9042 2.71667 18 3 18H16V2H18V20H3Z"
        fill={fill}
      />
    </svg>
  );
};

export const InterestIcon = ({
  width = 21,
  height = 22,
  fill = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M0 19.5V11.5H8V19.5H0ZM3.5 9L9 0L14.5 9H3.5ZM19.575 21.95L16.925 19.3C16.575 19.5333 16.1958 19.7083 15.7875 19.825C15.3792 19.9417 14.95 20 14.5 20C13.25 20 12.1875 19.5625 11.3125 18.6875C10.4375 17.8125 10 16.75 10 15.5C10 14.25 10.4375 13.1875 11.3125 12.3125C12.1875 11.4375 13.25 11 14.5 11C15.75 11 16.8125 11.4375 17.6875 12.3125C18.5625 13.1875 19 14.25 19 15.5C19 15.9333 18.9417 16.3542 18.825 16.7625C18.7083 17.1708 18.5417 17.55 18.325 17.9L20.975 20.55L19.575 21.95ZM16.275 17.275C16.7583 16.7917 17 16.2 17 15.5C17 14.8 16.7583 14.2083 16.275 13.725C15.7917 13.2417 15.2 13 14.5 13C13.8 13 13.2083 13.2417 12.725 13.725C12.2417 14.2083 12 14.8 12 15.5C12 16.2 12.2417 16.7917 12.725 17.275C13.2083 17.7583 13.8 18 14.5 18C15.2 18 15.7917 17.7583 16.275 17.275Z"
        fill={fill}
      />
    </svg>
  );
};

export const HeaderHamburger = ({ width = 37, height = 15 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34.665" height="2.59987" rx="1.29994" fill="#204A83" />
    <rect
      x="8.66614"
      y="5.19727"
      width="25.9987"
      height="2.59987"
      rx="1.29994"
      fill="#204A83"
    />
    <rect
      x="17.3325"
      y="10.4004"
      width="17.3325"
      height="2.59987"
      rx="1.29994"
      fill="#204A83"
    />
  </svg>
);

export const EyeIcon = ({ width = 15, height = 11 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49741 10.1553C7.35616 10.1553 7.2146 10.1515 7.07241 10.144C4.04835 9.98279 1.29366 8.09466 0.0549113 5.33341C-0.0863387 5.01841 0.0542862 4.64873 0.369286 4.50716C0.684599 4.36623 1.05397 4.50654 1.19554 4.82185C2.2446 7.15998 4.57741 8.75935 7.13897 8.8956C9.96585 9.04716 12.6443 7.40873 13.8052 4.82185C13.9465 4.50654 14.3165 4.36623 14.6315 4.50716C14.9465 4.64841 15.0871 5.01841 14.9458 5.33341C13.633 8.25873 10.6768 10.1553 7.49741 10.1553Z"
      fill="white"
    />
    <path
      d="M0.624911 5.703C0.539286 5.703 0.452411 5.68519 0.369286 5.648C0.0542862 5.50675 -0.0863387 5.13675 0.0549113 4.82175C1.42585 1.76675 4.59085 -0.165125 7.92804 0.0111246C10.9521 0.172375 13.7068 2.0605 14.9455 4.82175C15.0868 5.13675 14.9462 5.50644 14.6312 5.648C14.3165 5.78925 13.9465 5.64863 13.8049 5.33331C12.7558 2.99519 10.423 1.39581 7.86147 1.25956C5.03585 1.10862 2.35616 2.74644 1.19522 5.33331C1.09147 5.5655 0.863661 5.703 0.624911 5.703Z"
      fill="white"
    />
    <path
      d="M7.49781 7.6532C6.0775 7.6532 4.92188 6.49789 4.92188 5.07758C4.92188 3.65727 6.0775 2.50195 7.49781 2.50195C8.91813 2.50195 10.0738 3.65727 10.0738 5.07758C10.0738 6.49789 8.91813 7.6532 7.49781 7.6532ZM7.49781 3.75195C6.77906 3.75195 6.17188 4.35883 6.17188 5.07758C6.17188 5.79633 6.77906 6.4032 7.49781 6.4032C8.21656 6.4032 8.82375 5.79633 8.82375 5.07758C8.82375 4.35883 8.21656 3.75195 7.49781 3.75195Z"
      fill="white"
    />
  </svg>
);

